import React from 'react';
import { Typography } from '@mui/material';

import { ICategoryItem } from '../../../app/pages/home/categories/interfaces';
import { styles } from './styles';
import { useFormatMessage } from '../../../app/hooks';

export default function MoreItems({
  item,
  handleItem,
}: {
  item: ICategoryItem;
  handleItem: (id: number) => void;
}) {
  const { classes } = styles();
  const fm = useFormatMessage();
  const visibleCount = 6;
  const [expanded, setExpanded] = React.useState(true);
  const childrens = item.children?.filter(i => i.active) || [];
  const displayedItems = expanded ? childrens : childrens.slice(0, visibleCount);

  return (
    <div key={item.id} className={classes.blockChildren}>
      <Typography
        onClick={() => item.id && handleItem(item.id)}
        component='p'
        className={classes.childrenTitle}
      >
        {item.name}
      </Typography>
      {displayedItems?.map(j => (
        <Typography
          key={j.id}
          component='p'
          className={classes.titleChildren}
          sx={{ '&:hover': { color: '#205373' } }}
          onClick={() => j.id && handleItem(j.id)}
        >
          {j.name}
        </Typography>
      ))}
      {/* {childrens.length > visibleCount && (
        <Typography
          component='p'
          className={classes.moreItems}
          onClick={() => setExpanded(!expanded)}
        >
          {fm(expanded ? 'HIDE' : 'MORE')}
        </Typography>
      )} */}
    </div>
  );
}
